<template>
  <base-section
    id="404"
    class="text-center"
  >
    <v-container>
      <div class="hh-display hh-spectrum-text mb-4">
        404
      </div>
      <h1 class="hh-h2 mb-8">
        That page does not exist.
      </h1>
      <base-action-link
        :to="{ name: 'Home' }"
        accent
      >
        Back to home
      </base-action-link>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'FourOhFour',
  }
</script>
